<template>
    <div>
        <div class="box">
            <router-link to='/Jump'>
                <img style="width:19px;height:auto;" src="../../img/首页/菜单(2)@3x.png" alt="">
            </router-link>
            <div style="display: flex;justify-content: center;align-items: center;">
                <img style="width: 43px;height:23px;" src="../../img/首页/子拓logo@3x.png" alt="">
                <span style="font-size: 17px;color:#ffffff;padding-left:6px;">子拓国际贸易</span>
            </div>
            <p style="position: absolute;right: 45px;color: #ffff;font-size: x-small;">
                <span style="display: conten;" v-show="typefaces == 2" @click="typeface(1)">中文版</span>
                <span style="display: conten;" v-show="typefaces == 1" @click="typeface(2)">English</span>
            </p>
            <!-- <p><span style="padding-right:10px;cursor: pointer;" @click="typeface(1)">中文版</span>/<span style="padding-left:10px;cursor: pointer;" @click="typeface(2)">English version</span></p> -->
            <img class="bann_img" style="width:20px;height:18px;" @click="flantButton()" @mouseleave="logoFlant=false" src="../../img/首页/公众号@3x.png" alt="">
            <transition name="fade">
                <div class="img_img" style="position:absolute;top:40px;right:0;z-index:999;" v-if="logoFlant">
                    <img style="width:80px;height:80px;" src="../..//img/子拓公众号.jpg" alt="">
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

export default {
	name: 'Header',
	data () {
		return {
			logoFlant: false,
            typefaces: 1
		}
	},
    computed: {
      aaa() {
        return this.$root.TYPEFACE;
      }
    },
    watch: {
        aaa(type) {
            this.typefaces = type;
        }
    },

    mounted() {
        this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
    },

    methods: {

        typeface(type){
            this.$root.TYPEFACE = type;
            this.typefaces = type;
            this.$parent.fatherMethod(type);
        },

        flantButton() {
            let flant = this.logoFlant;
            this.logoFlant = !flant;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
.box {
    display: flex;
    background-color: #BB1E10;
    height: 49px;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    position: relative;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue